import { useState, useCallback } from "react"
import { APIError } from "../../../../../../app/modules/auth"
import { exportLeadListToCSV } from "../../../../../../mogul/core/_requests"
import { OriginalDataObjectFilterObject } from "./OriginalDataObjectFilterList"

export const useOriginalDataObjectExport = (typeOfExport: 'event_administrator' | 'event_check_in' | 'direct_mail_replies' | 'portal_leads', personSearchFilter?: string) => {
    const [exporting, setExporting] = useState(false)
    const [errorExporting, setErrorExporting] = useState<string | null>(null)

    const onExportLeadListToCSV = useCallback(
        async (filterObject: OriginalDataObjectFilterObject) => {
            setExporting(true)
            setErrorExporting(null)
            try {
                await exportLeadListToCSV({
                    type_of_export: typeOfExport,
                    filter: {
                        location_unique_ids: filterObject.selectedLocationUniqueIds || [],
                        start_unix_ts: filterObject.startingUnixTimestamp || undefined,
                        end_unix_ts: filterObject.endingUnixTimestamp || undefined,
                        person_search_filter: personSearchFilter || undefined,
                    },
                })
            } catch (exception) {
                console.error(exception)
                const errorMessage =
                    exception instanceof APIError ? exception.message : 'Failed to export leads';
                setErrorExporting(errorMessage)
            } finally {
                setExporting(false)
            }
        },
        [typeOfExport, personSearchFilter]
    )

    return {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    }
}
